export default __webpack_public_path__ + "static/media/notFound.756e08ac.svg";